import React from 'react'
import {Flex} from '/app/src/component'
class Invoice extends React.Component {
    render() {

        /*
        'local_draft',
        'remote_draft',
        'sent',
        'overdue',
    'paid', 'partial',
    'nullified'
        */
        let state;
        switch(this.props.invoice.status){
            case 'local_draft': state ='Ej Skickad'; break;
            case 'remote_draft': state ='Ej Skickad'; break;

            case 'sent': state ='Obetald'; break;
            case 'overdue': state ='Försenad'; break;
            case 'paid': state ='Betald'; break;
            case 'partial': state ='Delbetald'; break;
            case 'nullfied': state ='Krediterad'; break;
            default: state=this.props.invoice.status
        }
        return(
            <Flex w='100%' center borderBottom='1px solid lightgrey'>
                <Flex basis='20%' center>
                        {this.props.invoice.period_start} - {this.props.invoice.period_end}
                </Flex>
                <Flex basis='20%' center>
                        {this.props.invoice.due_date}
                </Flex>
                <Flex basis='20%' center>
                        {this.props.invoice.amount_due} :-
                </Flex>
                <Flex basis='20%' center>
                        {state}
                </Flex>
                <Flex basis='20%' center>
                        {this.props.invoice.ocr_nbr}
                </Flex>
            </Flex>
        );
    }

}

export default Invoice;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Invoice/Item.js